/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';

import Input from '@mui/material/Input';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlWithMargin from '../controls/FormControlWithMargin';

import { Field, getIn } from 'formik';

export const RenderTextField = ({
  field,
  form: { touched, errors, handleChange },
  normalizer,
  label,
  tooltip,
  inputProps,
  labelProps,
  ...others
}) => {
  const touch = getIn(touched, field.name);
  const error = getIn(errors, field.name);

  return (
    <FormControlWithMargin error={touch && error != null} {...others}>
      {tooltip && (
        <Tooltip title={tooltip}>
          <InputLabel shrink {...labelProps}>
            {label} <InfoOutlinedIcon style={{ verticalAlign: 'middle' }} color="action" />
          </InputLabel>
        </Tooltip>
      )}
      {!tooltip && label && (
        <InputLabel shrink {...labelProps}>
          {label}
        </InputLabel>
      )}
      <Input
        name={field.name}
        value={field.value}
        onChange={(e) => {
          if (normalizer) {
            handleChange(field.name)(normalizer(e.target.value));
          } else {
            field.onChange(e);
          }
        }}
        onBlur={field.onBlur}
        // inputProps={{ style: { textAlign: 'right', color: 'red' } }}
        {...inputProps}
      />
      {touch && error && <FormHelperText>{error}</FormHelperText>}
    </FormControlWithMargin>
  );
};

const FormTextField = ({ name, type, placeholder, ...others }) => {
  return <Field name={name} component={RenderTextField} inputProps={{ type, placeholder }} {...others} />;
};
export { FormTextField };
